<template>
  <div>
    <div class="rounded bg-white rounded p-12 mb-12 shadow-md">
      <AccountSubscriptionOrderForm :default-data="{}" />
    </div>
  </div>
</template>

<script>
import AccountSubscriptionOrderForm from '@/components/AccountSubscriptionOrders/AccountSubscriptionOrderForm.vue';

export default {
  name: 'AccountSubscriptionOrderUuid',

  components: {
    AccountSubscriptionOrderForm,
  },
};
</script>
